export const courseSettingsList = [
  { title: "Show on Discover", dbValue: "discover_page" },
  { title: "Is Public", dbValue: "is_public" },
  { title: "Promoted", dbValue: "promoted" },
  { title: "Disable Final Assessment", dbValue: "disable_final_assessment" },
  { title: "Hide Assessment Score", dbValue: "hide_assessment_score" },
  { title: "Show Latest Version", dbValue: "show_latest_version" },
]

export const ssoSettingsList = [
  { title: "Facebook SSO Required", dbValue: "facebook_sso_required" },
  { title: "Meta Quest SSO Required", dbValue: "meta_quest_sso_required" },
  { title: "Google SSO Required", dbValue: "google_sso_required" },
]
